import React, { forwardRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import useControlled from '../../utils/useControlled'
import withTheme from '../styles/withTheme'

import './Rf-checkbox.scss'

const Checkbox = forwardRef(function Checkbox(props, ref) {
	const {
		checked: checkedProp,
		className,
		defaultChecked,
		disabled,
		indeterminate = false,
		inputRef,
		onChange,
		onCheckedChange,
		...other
	} = props

	const [checked, setCheckedState] = useControlled({
		controlled: checkedProp,
		default: Boolean(defaultChecked)
	})

	const handleChange = (event) => {
		const newChecked = event.target.checked
		setCheckedState(newChecked)
		onCheckedChange && onCheckedChange(newChecked)
		onChange && onChange(event)
	}

	useEffect(() => {
		onCheckedChange && onCheckedChange(checkedProp)
	}, [checkedProp])

	return (
		<span ref={ref} className="Vb-checkbox__wrapper">
			<input
				ref={inputRef}
				type="checkbox"
				className={clsx('Vb-rf-checkbox', className, indeterminate && 'Vb-rf-checkbox--indeterminate')}
				checked={checked}
				onChange={handleChange}
				disabled={disabled}
				{...other}
			/>
		</span>
	)
})

export default withTheme('Vb-rf-checkbox')(Checkbox)

Checkbox.propTypes = {
	/**
	 * The content of the button.
	 */
	children: PropTypes.node,

	/**
	 * If `true`, the component is checked.
	 */
	checked: PropTypes.bool,

	/**
	 * If `true`, the component is disabled.
	 */
	disabled: PropTypes.bool,

	/**
	 * If `true`, the component is indeterminated.
	 */
	indeterminate: PropTypes.bool,

	/**
	 * Callback fired when the state is changed.
	 *
	 * @param {object} event The event source of the callback.
	 * You can pull out the new checked state by accessing `event.target.checked` (boolean).
	 */
	onChange: PropTypes.func,

	/**
	 * Callback fired when the checked prop is changed.
	 *
	 * @param {boolean} checked The event source of the callback.
	 */
	onCheckedChange: PropTypes.func,

	/**
	 * The value of the component. The DOM API casts this to a string.
	 */
	value: PropTypes.any
}
